import React, { useState, useEffect } from 'react';
import { Button, Grid, Stack, Typography, CircularProgress } from '@mui/material';
import MainTemplate from '../templates/MainTemplate';
import DocumentsForm from '../../components/DocumentsForm';
import WarrantyForm from '../../components/WarrantyForm';
import ConsentForm from '../../components/ConsentForm';
import useMdUpScreen from '../../hooks/useMdUpScreen';
import useIsMobile from '../../hooks/useIsMobile';

// El componente de UI solo recibe props
function CheckInStep2View({
    templateRef,
    viewParameters,
    warranty,
    loading,
    error,
    buttonPressed,
    onSetWarranty,
    onSubmit
}) {
    const mdUpScreen = useMdUpScreen();
    const mobile = useIsMobile();
    const [refreshSize,setRefreshSize] = useState(0);
	useEffect(()=>{
		setRefreshSize(refreshSize+1);
	},[mobile,warranty]);

    // Lógica para ajustar props dinámicamente si es necesario
    const containerProps = { ...viewParameters.transparentContainer, refreshSize };
    if (mobile && warranty) {
        containerProps.hm = "200%"; // Ajuste dinámico basado en estado
    }

    const layoutProps = { 
        ...viewParameters.layout, 
        extraBackground: !mdUpScreen, 
        extraBackgroundSx: 
            warranty ? viewParameters.warrantyExtraBackgroundSx : viewParameters.layout.extraBackgroundSx
    };
    
    return (
        <MainTemplate templateRef={templateRef} view={{ ...viewParameters, transparentContainer: containerProps, layout: layoutProps }}>
            <Grid spacing={0} container sx={{ height: 'auto' }}>
                <Grid item xs={12} md={warranty ? 6 : 12} sx={mobile ? viewParameters.estilos.gridItemMobile : viewParameters.estilos.gridItem}>
                <DocumentsForm showValidation={buttonPressed} error={error} refreshSize={()=>setRefreshSize(refreshSize+1)} />
                </Grid>
                {/* ... resto de tu JSX ... */}
                {!mdUpScreen && (<Grid item xs={12} sx={{ p: 1}}/>)}
                <Grid item xs={12} md={warranty ? 6 : 12} sx={mobile ? viewParameters.estilos.gridItemMobile : viewParameters.estilos.gridItem}>
                    {warranty ? <WarrantyForm showValidation={buttonPressed} /> : (
                        <Button variant="contained" sx={viewParameters.estilos.warrantyButton} onClick={() => onSetWarranty(true)}>
                            Agregar garantía (opcional)
                        </Button>
                    )}
                </Grid>
                {/* ... */}
                <Grid item xs={12} sx={{ p: 1 }}/>
                <Grid item xs={12} sx={{ px: (warranty || mobile) ? 1 : 5, height: '100%' }}>
                    <ConsentForm />
                </Grid>
                <Grid item xs={12} sx={{ p: 1 }}>
                    <Button disabled={loading} variant="contained" sx={viewParameters.estilos.submitButton} onClick={onSubmit}>
                        {loading ? <CircularProgress size={24} /> : 'Enviar archivos e información'}
                    </Button>
                </Grid>
            </Grid>
        </MainTemplate>
    );
}

export default CheckInStep2View;